import { defineMessages } from 'react-intl';

const messages = defineMessages({
  WorkByArtist: {
    defaultMessage: '"{workTitle}" by {artistName}',
    description:
      'The artwork and the artist that made it, used for the title of the page.'
  }
});

export default messages;
